<template>
    <div class="left-wrapper">
        <div class="title">重大工程</div>
        <div class="search-box">
            <el-input placeholder="请输入搜索内容" suffix-icon="el-icon-search" v-model="searchForm.name">
            </el-input>
        </div>
        <div class="plot-list">
            <YScroll style="height: 100%">
                <template>
                    <!-- <LBTree :treeData="treeData" :isParent="(data) => data.children">
                        <template v-slot:parent="ctx">
                            <div
                                class="c-mainpage-left__tree-item"
                                @click="ctx.row.showChildren = !ctx.row.showChildren"
                            >
                                <div class="c-mainpage-left__tree-item-name">
                                    {{ ctx.row.text + '('
                                    }}<span class="num">{{ ' ' + ctx.row.children.length + ' ' }}</span
                                    >)
                                </div>
                                <div
                                    class="
                                        c-mainpage-left__tree-item-icon c-mainpage-left__tree-item-icon--light
                                    "
                                >
                                    <i
                                        :style="{
                                            transform: ctx.row.showChildren
                                                ? 'rotate(180deg)'
                                                : 'rotate(0deg)',
                                        }"
                                        class="el-icon-arrow-down"
                                    ></i>
                                </div>
                            </div>
                        </template>
                        <template v-slot:children="ctx">
                            <div
                                @click="toDetailView(ctx.row, '1')"
                                class="c-mainpage-left__tree-item is-sub c-mainpage-left__tree-item--color1"
                            >
                                <div class="c-mainpage-left__tree-item-name tree_name" :title="ctx.row.name">
                                    <img :src="require('../../imgs/item.png')" alt="" />
                                    {{ ctx.row.text }}
                                </div>
                                <div class="c-mainpage-left__tree-item-icon">
                                </div>
                            </div>
                        </template>
                    </LBTree> -->
                    <CustomTree
                        :data="treeData"
                        :props="{ label: 'name' }"
                        :highlight-current="false"
                        @node-click="treeNodeClick"
                    ></CustomTree>
                </template>
            </YScroll>
        </div>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import { TreeUtil, tool } from '@Util';
// import LBTree from '../../../mainPage/components/LBTree.vue';
import * as Api from '../Api';
import CustomTree from '../../components/CustomTree';

export default {
    components: {
        YScroll,
        // LBTree,
        CustomTree,
    },
    props: {
        onDataSuccess: {
            // 获取到数据时会调用该函数
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            searchForm: {
                name: '',
            },

            organList: [], // 机构列表
            projectList: [], // 工程列表
        };
    },
    computed: {
        treeData() {
            let res = [];
            let organList = tool.deepCopy(this.organList);
            let projectList = this.projectList;

            let displayOrganList = TreeUtil.displayTree(organList);

            displayOrganList.forEach((item, index) => {
                let children = projectList.filter((pItem) => pItem.organId === item.id);
                let obj = item;
                obj.nodeType = 'folder';
                obj.name = item.text;
                if (obj.children) {
                    obj.children = obj.children.concat(children);
                } else {
                    obj.children = children;
                }
                // obj.children = children;
                // obj.showChildren = true;
                // if (index > 0) {
                //     obj.showChildren = false;
                // }
                // res.push(obj);
            });

            return organList;
        },
    },
    methods: {
        treeNodeClick(data, node) {
            this.$emit('treeChildreClick', data);
        },
        // 获取区域机构列表
        getOrganList() {
            let list = [];
            // Api.fetchOrganList()
            //     .run()
            //     .then((res) => {
            //         list = res || [];
            //         list.forEach((item) => {
            //             // 必须在这里加showChldren属性，否则树形展开不了，因为computed 里面treeData无法监测到showChildren变化
            //             item.showChildren = true;
            //         });
            //         this.organList = list;
            //     });
            Api.fetchOrganTree()
                .run()
                .then((res) => {
                    this.organList = res;
                });
        },
        // 获取工程列表
        getProjectList() {
            let list = [];
            let params = this.searchForm;
            Api.fetchProjectList(params)
                .run()
                .then((res) => {
                    list = res || [];
                    this.projectList = list;
                    if (typeof this.onDataSuccess === 'function') {
                        this.onDataSuccess(list);
                    }
                });
        },
    },
    mounted() {
        this.getOrganList();
        this.getProjectList();
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.left-wrapper {
    .title {
        padding-top: 11px;
        text-align: center;
        font-size: 18px;
        height: 37px;
        background-image: url(../../imgs/titlebg01.png);
    }

    .search-box {
        padding: 0 16px;
        padding-top: 11px;
    }

    ::v-deep .el-input__inner {
        border-color: #1a47a4;
        background-color: transparent;
    }

    .plot-list {
        margin-top: 11px;
        padding: 0 16px;
        height: 630px;
    }

    @include b(mainpage-left, c) {
        @include e(tree-item) {
            display: flex;
            justify-content: space-between;
            height: 30px;
            line-height: 30px;
            color: white;
            cursor: pointer;
            margin-bottom: 8px;

            @include when(sub) {
                padding-left: 5px;
            }

            @include m(color1) {
                background-image: linear-gradient(
                    90deg,
                    hsla(160, 65%, 61%, 60%) 0%,
                    hsla(160, 65%, 61%, 30%) 30%,
                    hsla(160, 65%, 61%, 30%) 70%,
                    hsla(160, 65%, 61%, 60%)
                );
                border: 1px solid hsla(160, 65%, 61%, 100%);
                border-left-width: 5px;
                vertical-align: middle;
            }

            @include m(color2) {
                background-image: linear-gradient(
                    90deg,
                    hsla(209, 100%, 51%, 60%) 0%,
                    hsla(209, 100%, 51%, 30%) 30%,
                    hsla(209, 100%, 51%, 30%) 70%,
                    hsla(209, 100%, 51%, 60%)
                );
                border: 1px solid hsl(209, 100%, 51%);
                border-left-width: 5px;
            }

            @include m(colorerror) {
                background-image: linear-gradient(
                    90deg,
                    hsla(339, 73%, 47%, 60%) 0%,
                    hsla(339, 73%, 47%, 30%) 30%,
                    hsla(339, 73%, 47%, 40%) 70%,
                    hsla(339, 73%, 47%, 60%)
                );
                border: 1px solid hsl(339, 73%, 47%);
                border-left-width: 5px;
            }

            @include m(colordisable) {
                background-image: linear-gradient(
                    90deg,
                    hsla(218, 31%, 48%, 60%) 0%,
                    hsla(218, 31%, 48%, 30%) 30%,
                    hsla(218, 31%, 48%, 30%) 70%,
                    hsla(218, 31%, 48%, 60%)
                );
                border: 1px solid hsl(218, 31%, 48%);
                border-left-width: 5px;
            }

            @include e(tree-item-name) {
                vertical-align: middle;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                // width: 100px;
                .num {
                    color: hsl(184, 97%, 64%);
                }

                img {
                    vertical-align: middle;
                }
            }

            .tree_name {
                width: 164px;
            }

            @include e(tree-item-icon) {
                @include m(light) {
                    color: hsl(184, 98%, 64%);
                }
            }
        }
    }
}
</style>
